import React from 'react';

// Catches render/commit errors within routed page content so a single bad
// page degrades to a fallback instead of unmounting the whole React root
// (which would otherwise kill client-side navigation entirely). Rendered
// keyed by location.pathname in App.js so it resets on every navigation.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught an error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-white px-6" data-testid="error-boundary-fallback">
          <div className="text-center">
            <p className="text-stone-500 mb-4">Something went wrong loading this page.</p>
            <a href="/" className="text-blue-900 underline underline-offset-2" data-testid="error-boundary-home-link">
              Go back home
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
